import React, { useContext, useState, useEffect } from "react";
import { AppContext } from "context/AppContext";
import UserManualComponent from "./UserManualComponent";

function UserManualContainer() {
  const { api } = useContext(AppContext);
  const [isLoading, setIsLoading] = useState(false);

  // para cargar cosas dinamicamente

  return (
    <UserManualComponent 
      isLoading={isLoading} 
    />
  );
}

export default UserManualContainer;